<div class="title-components title-subtitle">
  <h1>Roles generales Processes</h1>
</div>

<div class="Options-Menu">
  <!---================= CONTAINER SELECT TYPE =================--->

  <div class="Card-Option container-global-components">
    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fa-solid fa-users"></i>
      </div>
    </div>

    <div class="Container-Card">
      <div class="Option-Title">
        <h2>Opciones de roles</h2>
      </div>

      <div class="Input-Option DisplayInputs">
        <div class="Container-Buttons">
          <div
            [routerLink]="'/Dashboard/FIN/CreateRoleCDMSFIN'"
            class="Btn-Option Add button-square"
          >
            <span class="Tool-Tip">Agregar nuevo rol a finances</span>
            <i class="fa-solid fa-plus"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="Card-Option container-global-components">
    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fa-solid fa-gear"></i>
      </div>
    </div>

    <div class="Container-Card">
      <div class="Option-Title">
        <h2>Actualizar información</h2>
      </div>

      <div class="Input-Option DisplayInputs">
        <!---================= CONTAINER RELOAD PAGE =================--->
        <div class="Container-Buttons">
          <button (click)="Reload_Page()" class="Btn-Option button-square">
            <span class="Tool-Tip">Recargar pagina</span>
            <i class="fa-solid fa-rotate-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div></div>
  <div></div>
</div>

<!--&================== CONTAINER GENERAL LIBRARY ==================&-->
<div class="container-global-components ConFLCCP">
  <!---================= CONTAINER DIVIDER BUTTONS =================--->

  <div class="Table-Lib Table-container-Global">
    <p-table
      #dt
      [value]="Roles"
      [(selection)]="Selected_Roles"
      dataKey="id"
      [rowHover]="true"
      [rows]="10"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10, 15, 25, 50]"
      [paginator]="true"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
      [filterDelay]="0"
      [globalFilterFields]="['Name', 'Description']"
    >
      <!--&================= SEARCH AND ALL Groups =================&-->
      <ng-template pTemplate="caption">
        <div class="SectionCreateTotal Section-Groups Table_NG">
          <div class="left-CT">
            <div class="search inputText">
              <i class="fa-solid fa-magnifying-glass"></i
              ><input
                [(ngModel)]="Role_Filter"
                type="text"
                (input)="dt.filterGlobal(Role_Filter, 'contains')"
                placeholder="Buscar rol"
              />
            </div>
          </div>
          <div class="right-CT">
            <div class="AllFiles">
              Total de Roles: <b>{{ Roles.length }}</b>
              <i class="fa-solid fa-users"></i>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <ng-container *ngFor="let Header of Headers_Shared">
            <ng-container *ngIf="Header.Key_Header === 'NAM'">
              <th pSortableColumn="Name" class="{{ Header.Key_Header }}">
                <div class="Grid-Th">
                  <span>{{ Header.Name }}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Name"></p-sortIcon>
                    <p-columnFilter
                      type="text"
                      field="Name"
                      display="menu"
                      class="ml-auto"
                    ></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'DES'">
              <th pSortableColumn="Description" class="{{ Header.Key_Header }}">
                <div class="Grid-Th">
                  <span>{{ Header.Name }}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Description"></p-sortIcon>
                    <p-columnFilter
                      type="text"
                      field="Description"
                      display="menu"
                      class="ml-auto"
                    ></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'DEL'">
              <th>
                <!-- <i class="fa-regular fa-trash-can"></i> -->
              </th>
            </ng-container>
          </ng-container>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-Roles>
        <tr>
          <td
            *ngFor="let Header of Headers_Shared"
            class="{{ Header.Key_Header }}"
          >
            <ng-container *ngIf="Header.Key_Header === 'NAM'">
              {{ Roles.Name }}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'DES'">
              {{ Roles.Description }}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'DEL'">
              <div
                [routerLink]="['/Dashboard/FIN/UsersRoleFIN/', Roles.ID]"
                class="Btn-Option button-square"
              >
                <i class="fa-solid fa-users"></i>
              </div>
              <div
                [routerLink]="['/Dashboard/FIN/EditeRoleFIN/', Roles.ID]"
                class="Btn-Option button-square Edit"
              >
                <i class="fa-solid fa-pencil"></i>
              </div>
              <div
                (click)="Delete_Role(Roles)"
                class="Btn-Option button-square Delete"
              >
                <i class="fa-regular fa-trash-can"></i>
              </div>
            </ng-container>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td *ngIf="Roles.length > 0" colspan="8">Sin coincidencias.</td>
        </tr>
        <tr>
          <td colspan="20">
            <div class="Not-Groups" *ngIf="Roles.length === 0 && LoadPage">
              <div class="Img-Not">
                <img src="./assets/Global/Ilustrations/Role.png" alt="" />
              </div>
              <div class="Text-Not-Groups">
                Aún no existen roles en Processes.
              </div>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<!--~===================================== SECTION ALL MODALS =====================================~-->

<!---===================== MODAL FOR LOADER COMPONENT =====================--->
<div class="Container-Loader-Global" id="Loader">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>
